export * from './generated/region-supported-languages.bk';
